import { render, staticRenderFns } from "./ListPermission.vue?vue&type=template&id=0d2c1ddb&"
import script from "./ListPermission.vue?vue&type=script&lang=js&"
export * from "./ListPermission.vue?vue&type=script&lang=js&"
import style0 from "./ListPermission.vue?vue&type=style&index=0&id=0d2c1ddb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports